import { CONSORS_CONSORSCUSTOMERADVERTISMENTCONSENTS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsCustomerAdvertisementConsent = z.nativeEnum(CONSORS_CONSORSCUSTOMERADVERTISMENTCONSENTS);
export type SchemaConsorsCustomerAdvertisementConsent = z.infer<typeof schemaConsorsCustomerAdvertisementConsent>;
